exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.offline-wrapper[data-v-87b029dc]{\n    width: 100%;\n    height: 100vh;\n    position: relative;\n}\n.offline-inner[data-v-87b029dc]{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: auto;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    max-width: 600px;\n    background: rgba(255,255,255,0.95);\n    border-radius: 4px;\n    padding: 0px 30px 30px 30px;\n    text-align: center;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.02), 0 4px 10px 0 rgba(0, 0, 0, 0.08);\n}\np.description[data-v-87b029dc]{\n    margin: 10px 0px;\n    font-weight: 300;\n}\nh1[data-v-87b029dc]{\n    font-weight: bold;\n    margin-bottom: 0;\n    margin-top: 0;\n}\nh3[data-v-87b029dc]{\n    font-weight: 400;\n    margin-top: 0px;\n}\n.icon[data-v-87b029dc]{\n    color: #333;\n    font-size: 100px;\n    margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-87b029dc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/core/offline.vue
// module id = 583
// module chunks = 0